import {useContext, useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import {autorun} from 'mobx';
import RootStoreContext from '../model/RootStoreContext';
import type {IGameVersion} from '../model/gameVersion/GameVersion';
import {usePublishSnackbarNotification} from '@yakoffice/snackbar';


interface useGameVersionResult {
    isLoaded: boolean;
    gameVersion: IGameVersion | null;
}


export const useGameVersion = () => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();
    const {gameVersionId} = useParams<{ gameVersionId: string }>();
    const [result, setResult] = useState<useGameVersionResult>({
        isLoaded: false,
        gameVersion: null
    });
    const effectRan = useRef(false);

    const abortController = new AbortController();

    useEffect(() => {
        setResult({isLoaded: false, gameVersion: null});

        if (gameVersionId !== undefined) {
            rootStore.gameVersionStore
                .getGameVersion(parseInt(gameVersionId))
                .then((gameVersion) => {
                    setResult({isLoaded: true, gameVersion: gameVersion});
                    const signal = abortController.signal;
                })
                .catch((e) =>
                    publishNotification({
                        text: `Error loading game version: ${e.message}`,
                        canClose: true,
                    })
                );
        } else {
            setResult({isLoaded: true, gameVersion: rootStore.gameVersionStore.addGameVersion()});
        }

        return () => {
            rootStore.gameVersionStore.clearCurrentGameVersion();
            abortController.abort();
            effectRan.current = true;
        };
    }, [rootStore.gameVersionStore, publishNotification, gameVersionId]);

    return result;
};
